import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { IndicateurModel, DiagnosticModel, ObjectifModel } from '../../main/Models';
import { ApiService, DialogsService } from '../../custom-material/Services/';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PreconizationComponent } from '../preconization/preconization.component';
import { ObjectifFormComponent } from '../objectif-form/objectif-form.component';
import { Router } from '@angular/router';
import { globalData } from 'src/app/main/Models/global.model';
import { TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'rm-indicator',
  templateUrl: './t_indicator.component.html',
  styleUrls: ['./indicator.component.less']
})
export class IndicatorComponent implements OnInit {

  @Input('indicator') indicator:IndicateurModel;
  @Input('diagnostic') diagnostic:DiagnosticModel;
  @Input('objectif') objectif:ObjectifModel;
  @Input('embedded') embedded:boolean = false;

  @Output() onOpenObjectif:EventEmitter<ObjectifModel> = new EventEmitter();


  constructor(private apiService: ApiService,
              private dialog: MatDialog,
              private dialogService:DialogsService,
              private snackBar: MatSnackBar,
              private router: Router,
              private gd: globalData,
              private translateService:TranslocoService) { }

  ngOnInit() {
    if(this.embedded) this.loadPreco(this.indicator).then(()=>{});
  }

  loadPreco(indicator:IndicateurModel)
  {
  	return new Promise((resolve, reject)=>{

  	  if(indicator.preco!=undefined) { resolve(indicator.preco); return; }

  	  let params = this.apiService.createParams({indicator: indicator.id}, 'ismemberof');
	    this.apiService.getFromServer('preconization', params)
       .then(s => s.subscribe((response:any) => {
         if(response._embedded.preconization.length==0) {
           reject('Aucune préconisation trouvée');
           return;
         }

         indicator.preco = response._embedded.preconization[0];
         if(indicator.preco) {
           resolve(indicator.preco); 
           return;
         }
       })); 
  	});
  }

  showPreco(indicator:IndicateurModel)
  {
  	this.loadPreco(indicator)
  	.then((preco)=>{
        		/*const dialogRef = this.dialog.open(PreconizationComponent, {
  	      width: '600px',
  	      height: '450px',
  	      data: { 
  	        preco: preco
  	      }
  	    });*/

  	}).catch((msg)=>{
      console.warn(msg);
  		/*const dialogRef = this.dialog.open(PreconizationComponent, {
          width: '600px',
          height: '450px',

          data: { 
            preco: {preco: msg}
          }
        });*/
  	});
  }
  /*/*
  createObjectif(indicator:IndicateurModel)
  {
    const dialogRef = this.dialog.open(ObjectifFormComponent, {
      width: '900px',
      height: '400px',
      data: { 
        indicator: indicator, 
        answer: indicator.answer,
        building: this.diagnostic.building,
        diagnostic: this.diagnostic
      }
    });

    dialogRef.afterClosed().subscribe((objectif:ObjectifModel) => {
      if(!objectif) return;

      this.snackBar.open('Sauvegarde en cours')
      this.apiService.SaveToServer('objectif', objectif.export())
        .then(s => s.subscribe((response:any) => {
          this.snackBar.open('Objectif sauvegardé');
          indicator.answer.objectif = new ObjectifModel(response);
          this.openObjectif();
          setTimeout(()=>{ this.snackBar.dismiss() }, 2000);
        }))
    });
  }
  //*/
  newObjectif()
  {
    this.snackBar.open('Création du nouvel objectif');
    let now = new Date();
    let today = now.toISOString().split('T')[0];
    let newObjectif = new ObjectifModel({
      name: this.indicator.name,
      answer: this.indicator.answer,
      building: this.diagnostic.building,
      diagnostic: this.diagnostic,
      start:{date: today},
      end: {date: today},
      status: 0
    });
    this.apiService.SaveToServer('objectif', newObjectif.export())
      .then(s => s.subscribe((response:any) => {
        setTimeout(()=>{ this.snackBar.dismiss() }, 0);
        this.snackBar.open('Objectif créé');
        this.indicator.answer.objectif = new ObjectifModel(response);

        let message = this.translateService.translate("rm-indicator-create-confirm-message");
        let title = this.translateService.translate("rm-indicator-create-confirm-title");
        
        setTimeout(()=>{ 
          this.snackBar.dismiss() ;
          this.dialogService.confirm(message, title )
            .subscribe(confirm=>{
              if(confirm) this.openObjectif();
            });
        }, 1000);
      }) );
  }

  openObjectif()
  {
    //this.onOpenObjectif.emit();
    this.gd.current = this.indicator.answer.objectif;
    this.gd.back = {
      //goto: ['/','rm','generator', this.diagnostic.id],
      diagnostic: this.diagnostic.id,
      indicator: this.indicator
    }

    this.router.navigate(['/rm','objectifs', this.indicator.answer.objectif.id]);
  }
}
